import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  title: {
    id: 'portal.views.resetPassword.label.title',
    defaultMessage: 'Reset Your Password',
    description: 'Reset password page heading',
  },
  instructions: {
    id: 'portal.views.resetPassword.label.instructions',
    defaultMessage: 'Enter and confirm your new password.',
    description: 'Instructions text',
  },
  fieldNewPassword: {
    id: 'portal.views.resetPassword.field.newPassword.placeholder',
    defaultMessage: 'New Password',
    description: 'New password placeholder',
  },
  fieldConfirmPassword: {
    id: 'portal.views.resetPassword.field.confirmPassword.placeholder',
    defaultMessage: 'Confirm Password',
    description: 'Confirm password placeholder',
  },
  reset: {
    id: 'portal.views.resetPassword.button.reset',
    defaultMessage: 'Reset my password',
    description: 'Reset password button',
  },
  enterPassword: {
    id: 'portal.views.resetPassword.validation.enterPassword',
    defaultMessage: 'Enter your new password',
    description: 'Validation: empty password',
  },
  errorTitle: {
    id: 'portal.views.resetPassword.error.title',
    defaultMessage: 'Error',
    description: 'Error notification title',
  },
  tooManyAttempts: {
    id: 'portal.views.resetPassword.error.tooManyAttempts',
    defaultMessage: 'Too many attempts. Please try again later.',
    description: 'Too many attempts error',
  },
  internalServerError: {
    id: 'portal.views.resetPassword.error.internalServerError',
    defaultMessage: 'An unexpected error occurred. Please try again.',
    description: 'Internal server error',
  },
});

export default messages;
